<div class="main">
    <div class="flex justify-between items-center flex-wrap py-2 px-4">
        <div class="flex gap-8">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                <span>Shift Management</span>
            </h3>
            <div>
                <select id="department" [ngModel]="departmentId()" class="textField" (ngModelChange)="onDepartmentChange($event)">
                    <option [ngValue]="null" hidden disabled selected>Choose a Department</option>
                    @for (dept of $$departmentDTO(); track dept.departmentId) {
                    <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                    }
                </select>
            </div>
        </div>
        
        
        <div class="flex gap-4 justify-end">
            <button class="button-blue" (click)="openShiftAdd()">Add New Shift</button>
        </div>
    </div>

    <div class="overflow-x-auto pt-2 max-h-[70vh]">
        <div class="table-wrapper overflow-x-auto">
            <table class="table">
                <thead class="table-thead">
                    <tr>
                        <th scope="col" class="px-6 py-3">Department</th>
                        <th scope="col" class="px-6 py-3">End Time</th>
                        <th scope="col" class="px-6 py-3">Is Tempory</th>
                        <th scope="col" class="px-6 py-3">Machines</th>
                        <th scope="col" class="px-6 py-3">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    @for (shift of $$ShiftDTO(); track shift) {
                        <tr class="bg-white border-b hover:bg-blue-100 cursor-pointer">
                            <td class="px-6 py-2 text-sm">{{ shift.department| uppercase }}
                            <td class="px-6 py-2 text-sm">{{ shift.shiftName| uppercase }}
                            <td class="px-6 py-2 text-sm">
                                <span [class]="shift.isTemporary ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'"
                                    class="text-xs font-medium px-2 py-0.5 rounded-full">
                                    {{ shift.isTemporary ? 'Yes' : 'No' }}
                                </span>
                            </td>
                            <td class="px-6 py-2 text-sm">
                                @if (shift.machines && shift.machines.length > 0) {
                                    <div class="flex flex-wrap gap-1">
                                        @for (machine of shift.machines; track machine.machineId) {
                                            <span class="inline-block bg-blue-100 text-blue-700 text-xs px-2 py-0.5 rounded-full">
                                                {{ machine.machineName }}
                                            </span>
                                        }
                                    </div>
                                } @else {
                                    <span class="text-gray-400 text-xs">—</span>
                                }
                            </td>
                            <td class="px-6 py-4">
                                <svg (click)="openShiftEdit(shift)"
                                    width="20" height="20"
                                    class="cursor-pointer hover:scale-110 transition-transform"
                                    viewBox="0 0 20 20" fill="none">
                                    <path d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                                        stroke="#38648e" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="12" class="px-6 py-10">
                                <div class="flex flex-col items-center justify-center text-center">
                                    <p class="text-xl font-semibold text-gray-700 mb-2">No Any Shifts
                                        Found</p>
                                    <p class="text-gray-500">We couldn't find any defined shifts</p>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

@if(modal.$$AddShiftModal()){
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 w-full max-w-3xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                    <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                        <!-- Title changes based on mode -->
                        <span>{{ editShiftId() !== null ? 'Edit Shift' : 'Add New Shift' }}</span>
                        <span class="status-badge ml-4"></span>
                    </h3>
                    <button type="button"
                        (click)="modal.$$AddShiftModal.set(false); editShiftId.set(null)"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
            </div>
 
            <div class="p-4 space-y-4">
 
                <!-- Shift Name -->
                <div>
                    <label class="block text-sm font-medium mb-1">Shift Name</label>
                    <input type="text"
                        [ngModel]="shiftForm().shift"
                        (ngModelChange)="updateShiftName($event)"
                        class="textField w-full"
                        placeholder="Enter shift name">
                </div>
 
                <!-- Time -->
                @if (editShiftId() === null) {
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium mb-1">Start Time</label>
                        <input type="time"
                            [(ngModel)]="shiftForm().startTime"
                            class="textField w-full">
                    </div>
                    <div>
                        <label class="block text-sm font-medium mb-1">End Time</label>
                        <input type="time"
                            [(ngModel)]="shiftForm().endTime"
                            class="textField w-full">
                    </div>
                </div>
                }
 
                <!-- Temporary -->
                <div class="flex items-center gap-2">
                    <input type="checkbox"
                        [(ngModel)]="shiftForm().isTemporary"
                        [disabled]="editShiftId() !== null"
                        [class.opacity-50]="editShiftId() !== null"
                        [class.cursor-not-allowed]="editShiftId() !== null">
                    <label class="text-sm" [class.text-gray-400]="editShiftId() !== null">
                        Temporary Shift
                        @if (editShiftId() !== null) {
                            <span class="ml-1 text-[10px] text-gray-400 italic">(cannot change after creation)</span>
                        }
                    </label>
                </div>
 
                <!-- Machines Selection / Times -->
                @if (shiftForm().isTemporary || editShiftId() !== null) {
                    <div class="mt-4 flex flex-col md:flex-row gap-4 md:h-72 lg:h-96">
                        <!-- Left Side: Machine List -->
                        <div class="w-full md:w-1/2 border rounded-lg overflow-hidden flex flex-col bg-white shadow-sm h-100 md:h-full">
                            <!-- Search Header -->
                            <div class="bg-gray-50 border-b">
                                <div class="px-3 py-2 border-b border-gray-200 flex justify-between items-center">
                                    <span class="text-sm font-medium text-gray-700">Selected Machines</span>
                                   
                                
                                </div>
                                <div class="px-3 py-2">
                                    <div class="relative">
                                        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                            <svg class="w-4 h-4 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                                            </svg>
                                        </div>
                                        <input type="text" [(ngModel)]="searchQuery" class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-9 p-2" placeholder="Search machines...">
                                    </div>
                                </div>
                            </div>
                            
                            <!-- List Body -->
                            <div class="flex-1 overflow-y-auto bg-white p-2 space-y-1.5">
                                @for (machine of filteredMachines(); track machine.machineId) {
                                    @if (shiftForm().isTemporary || isMachineSelected(machine.machineId)) {
                                    <div class="flex items-center gap-3 p-2.5 rounded-md cursor-pointer transition-colors border"
                                         [class.bg-blue-50]="selectedEditMachineId() === machine.machineId"
                                         [class.border-blue-300]="selectedEditMachineId() === machine.machineId"
                                         [class.border-gray-100]="selectedEditMachineId() !== machine.machineId"
                                         [class.hover:bg-gray-50]="selectedEditMachineId() !== machine.machineId"
                                         (click)="selectMachineForEdit(machine.machineId)">
                                        <input type="checkbox"
                                            class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer"
                                            [checked]="isMachineSelected(machine.machineId)"
                                            [disabled]="editShiftId() !== null && !shiftForm().isTemporary"
                                            (click)="$event.stopPropagation()"
                                            (change)="onMachineToggle(machine.machineId, $event)">
                                        <span class="text-sm font-medium text-gray-700 truncate" [title]="machine.machineName">
                                            {{ machine.machineName }}
                                        </span>
                                    </div>
                                    }
                                } @empty {
                                    <div class="px-4 py-8 text-center text-sm text-gray-500">
                                        No machines found matching your search.
                                    </div>
                                }
                            </div>
                        </div>

                        <!-- Right Side: Edit Form -->
                        <div class="w-full md:w-1/2 h-auto md:h-full">
                            @if (selectedEditMachineId() || isEditingNewMachines()) {
                                <div class="bg-white p-5 rounded-lg border shadow-sm h-full flex flex-col">
                                    <div class="mb-4 pb-3 border-b border-gray-100">
                                        <h4 class="text-sm font-semibold text-gray-800">
                                            {{ isEditingNewMachines() ? 'Configure Time for New Machines' : 'Configure Machine Time' }}
                                        </h4>
                                        <p class="text-xs text-blue-600 mt-1.5 font-medium">
                                            {{ isEditingNewMachines() ? getNewMachineNames() : getSelectedMachineName() }}
                                        </p>
                                    </div>
                                    
                                    <div class="space-y-4 flex-1">
                                        <div>
                                            <label class="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1.5">Start Time</label>
                                            <input type="time" [(ngModel)]="machineEditForm().startTime" class="textField w-full text-sm p-2">
                                        </div>
                                        <div>
                                            <label class="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1.5">End Time</label>
                                            <input type="time" [(ngModel)]="machineEditForm().endTime" class="textField w-full text-sm p-2">
                                        </div>
                                    </div>
                                    
                                    @if (!isEditingNewMachines()) {
                                    <div class="pt-5 mt-auto border-t border-gray-100">
                                        <button type="button" 
                                                class="w-full button-blue flex justify-center items-center py-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
                                                (click)="saveMachineTime()">
                                            Update Machine Time
                                        </button>
                                        <p class="text-[10px] text-gray-400 text-center mt-2.5">
                                            Changes are saved immediately to the server.
                                        </p>
                                    </div>
                                    } @else {
                                    <div class="pt-5 mt-auto border-t border-gray-100">
                                        <p class="text-[11px] font-medium text-amber-600 text-center mt-2.5 bg-amber-50 p-2 rounded border border-amber-100">
                                            Click "Update Shift" below to save these newly added machines.
                                        </p>
                                    </div>
                                    }
                                </div>
                            } @else {
                                <div class="bg-gray-50 border border-dashed border-gray-300 rounded-lg h-full flex flex-col items-center justify-center p-6 text-center text-gray-400 min-h-[200px]">
                                    <svg class="w-10 h-10 mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <p class="text-sm font-medium text-gray-500">No Machine Selected</p>
                                    <p class="text-xs mt-1.5 leading-relaxed">Select a machine from the list on the left to configure its specific start and end time.</p>
                                </div>
                            }
                        </div>
                    </div>
                }
 
                <!-- Actions -->
                <div class="flex justify-end gap-3 pt-4">
                    <button class="button-secondary"
                        (click)="modal.$$AddShiftModal.set(false); editShiftId.set(null)">
                        Cancel
                    </button>
 
                    <!-- Button label changes based on mode -->
                    <button class="button-blue disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="editShiftId() !== null && !canUpdateShift()"
                        (click)="saveShift()">
                        {{ editShiftId() !== null ? 'Update Shift' : 'Save Shift' }}
                    </button>
                </div>
 
            </div>
        </div>
    </div>
}